<!-- https://8es9hr.axshare.com/#g=1&p=%E6%97%A5%E7%B5%90%E4%BD%9C%E6%A5%AD_%E4%B8%BB%E7%AE%A1%E5%95%9F%E5%8B%95
     https://8es9hr.axshare.com/#g=1&p=%E6%97%A5%E7%B5%90%E4%BD%9C%E6%A5%AD_%E4%B8%BB%E7%AE%A1%E9%97%9C%E5%B8%B3-->
<!-- 日結作業_主管啟動
     日結作業_主管關帳 -->
<template>
    <div style="display: flex">
        <Step :workflow="workflow" v-if="type > 1"></Step>
        <div class="bgf" :class="{'step-form': type > 1, 'w100p': type == 1 }">
            <div class="col-block">
                <div class="block-header has-border">
                    <h3>
                        <strong>{{ $transferDate(settleDate) }} 結帳作業</strong>
                    </h3>
                </div>
                <!-- 主管啟動 -->
                <div class="block-content" v-if="type == 1">
                    <el-button type="primary" plain @click="SettlementMgr('start')">啟動結帳作業，不得再入帳</el-button>
                </div>
                <!-- 主管關帳 -->
                <div class="block-content" v-if="type == 5">
                    <p
                        class="sub_title"
                    >今日開立收款單數量 : {{recordToEdit.voucherStatistic.cashVoucherCount}}</p>
                    <router-link
                        :to="{ name: 'coop_receipt', query: { settleDate: settleDate }}"
                        target="_blank"
                    >
                        <el-button type="primary" plain>收款單管理</el-button>
                    </router-link>
                    <p
                        class="sub_title"
                    >支出轉帳傳票數量 : {{recordToEdit.voucherStatistic.transferVoucherCount}}</p>
                    <router-link
                        :to="{ name: 'expense_summons', query: { settleDate: settleDate }}"
                        target="_blank"
                    >
                        <el-button type="primary" plain>支出轉帳傳票管理</el-button>
                    </router-link>
                    <p
                        class="sub_title"
                    >庫存現金餘額 : {{$addcomma(recordToEdit.dailySettlement.cashOnHand)}}</p>
                    110 現金 傳票結餘 : {{$addcomma(recordToEdit.cashOnHandBalance)}}
                    <div v-for="item in recordToEdit.bankList">
                        <p class="sub_title" v-if="item.ddAccountTitleId">
                            {{item.bankName}} 活存餘額
                            {{$addcomma(recordToEdit.bankStatistic[item.ddAccountTitleId].keyInBalance)}}
                        </p>
                        <p v-if="item.ddAccountTitleId">
                            {{item.bankName}} 活存傳票結餘
                            {{$addcomma(recordToEdit.bankStatistic[item.ddAccountTitleId].balance)}}
                        </p>
                    </div>
                    <el-button type="primary" plain @click="SettlementMgr('confirm')">確認結帳</el-button>
                    <el-button type="danger" plain @click="SettlementMgr('cancel')">中止結帳作業</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Step from "@/components/Step.vue";
import { API } from "@/assets/config";

export default {
    name: "daily_supervisor",
    components: { Step },
    data() {
        return {
            type: 0, // 1~5
            recordToEdit: {
                statistic: {},
                creatorList: {},
                voucherStatistic: {},
                cashOnHand: "",
                dailySettlement: {}
            },
            workflow: [],
            settleDate: "",
            dailyStatus: ""
        };
    },
    created() {
        // 假設開始取得角色權限為主管
        this.type = 1;
    },
    watch: {
        type() {
            if (this.type == 1) {
                // 主管
                this.getTodayStatus();
            } else if (this.type == 5) {
                // 主管
                this.gettlementMgr();
            }
        }
    },
    methods: {
        getTodayStatus() {
            const url = API.dailySettlementMgr + `?action=getTodayStatus`;
            const thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData
                );
                this.dailyStatus = json.resultData;
                if (this.dailyStatus == 2) {
                    // dailyStatus 為 2 時 主管關帳
                    this.type = 5;
                    // 傳票日期
                    this.settleDate = json.resultData.dailySettlement.settleDate.split(
                        " "
                    )[0];
                }
            };
            this.mAxiosGet(url, thenCB);
        },
        gettlementMgr() {
            const url = API.dailySettlementMgr + `?action=getData`;
            const thenCB = json => {
                if (json.resultData.status == 1) {
                    // 代表未關帳
                    this.$router.push({
                        name: "daily"
                    });
                }
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData
                );
                // 傳票日期
                this.settleDate = json.resultData.dailySettlement.settleDate.split(
                    " "
                )[0];
                this.workflow = json.resultData.workflow;
            };
            const thenCatch = error => {
                const errorCode = (error && error.response && error.response.data)
                    ? error.response.data.ErrorCode
                    : null;
                // 當 errorMessage 顯示 系統資料錯誤 就導回 daily
                if (errorCode === "ES0013") {
                    this.$router.push({
                        name: "daily"
                    });
                } else {
                    this.getErrorHandler(error);
                }
            };
            this.mAxiosGet(url, thenCB, {}, false, thenCatch);
        },
        SettlementMgr(action) {
            var url = API.dailySettlementMgr + `?action=${action}`;
            const form = new FormData();

            let thenCB = json => {
                this.showAjaxSuccessMsg();
                this.gettlementMgr();
            };
            this.mAxiosPost(url, form, thenCB);
        },
        SettlementClose(api) {
            try {
                this.checkAmount();
            } catch (error) {
                this.$message.error(error.message);
                return;
            }

            var url = API[api];
            const form = new FormData();

            let thenCB = json => {
                this.showAjaxSuccessMsg();
            };
            this.mAxiosPost(url, form, thenCB);
        },
        checkAmount() {
            if (
                this.recordToEdit.dailySettlement.cashOnHand !==
                this.recordToEdit.cashOnHandBalance
            ) {
                throw new Error("現金餘額不一致");
            }
            this.recordToEdit.bankList.forEach(item => {
                if (
                    this.recordToEdit.bankStatistic[item.ddAccountTitleId]
                        .keyInBalance !==
                    this.recordToEdit.bankStatistic[item.ddAccountTitleId]
                        .balance
                ) {
                    throw new Error(`${item.bankName} 活存餘額不一致`);
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.block-content {
    line-height: 34px;

    p {
        margin-bottom: 4px;
    }

    .sub_title {
        margin-bottom: 0px;
        font-weight: bold;
    }

    table {
        width: 200px;
        display: inline-table;
        margin-right: 10px;

        td {
            padding: 4px 10px;
            text-align: center;
        }
    }

    .box-card {
        margin-top: 10px;
    }
}

.step {
    cursor: pointer;
}
</style>